import { Component, input, computed } from '@angular/core';
import { Article, Sources } from './help-center-articles';

@Component({
  selector: 'app-help-search-card',
  templateUrl: './help-search-card.component.html',
  styleUrls: ['./help-search-card.component.scss'],
  standalone: false,
})
export class HelpSearchCardComponent {
  article = input<Article>();

  icon = computed(() => this.getIconForSource(this.article()));

  private getIconForSource(article: Article): string {
    if (!article) return 'book';

    switch (article.source) {
      case Sources.ZD_COMMUNITY_POST:
        return 'groups';
      case Sources.ZD_RESOURCE_CENTER:
        return 'article';
      case Sources.CL_PODCAST:
        return 'podcasts';
      case Sources.CL_VIDEO:
        return 'videocam';
      case Sources.CL_GROUP:
        return 'group';
      case Sources.OPEN_API:
        return 'api';
      default:
        return 'book';
    }
  }

  openArticle(): void {
    window.open(this.article().link, '_blank', 'noopener');
  }
}
